import { render } from "./LandWebView.vue?vue&type=template&id=ca858180&scoped=true"
import script from "./LandWebView.vue?vue&type=script&lang=js"
export * from "./LandWebView.vue?vue&type=script&lang=js"

import "./LandWebView.vue?vue&type=style&index=0&id=ca858180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca858180"]])

export default __exports__